import { Breadcrumbs } from '@mui/material';
import { Link } from 'react-router-dom';

interface BreadcrumbProps {
  routes: {
    path: string;
    breadcrumbName: string;
  }[];
}

const Breadcrumb = ({ routes }: BreadcrumbProps) => {
  return (
    <Breadcrumbs separator='&rsaquo;' className='flex' sx={{ minHeight: '42px' }}>
      {routes.map((route) => {
        return (
          <Link key={route.path} color='inherit' to={route.path}>
            {route.breadcrumbName}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
